import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CheckInSummaryModel } from "./check-ins-statuses";
import {
  CheckInsSummarySurveyListComponent
} from "../check-ins-summary-survey-list/check-ins-summary-survey-list.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CheckInsSummaryPopUpComponent } from "../check-ins-summary-pop-up/check-ins-summary-pop-up.component";

export interface SurveysToDisplay {
  name: string;
  label: string;
  statusIcon: string;
}

@Component({
  selector: 'lib-check-ins-summary',
  standalone: true,
  imports: [
    CheckInsSummarySurveyListComponent
  ],
  templateUrl: './check-ins-summary.component.html',
  styleUrl: './check-ins-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckInsSummaryComponent {
  private readonly modalService = inject(NgbModal);

  readonly petId = input<string>('');
  readonly ownerId = input<string>('');
  readonly checkInsSummary = input<CheckInSummaryModel[] | null>(null);
  readonly app = input<number>(0);

  openCheckInsModal(surveyName: string): void {
    const modalRef = this.modalService.open(CheckInsSummaryPopUpComponent, {
      backdrop: 'static',
      centered: true
    });
    modalRef.componentInstance.checkInsSummary = this.checkInsSummary();
    modalRef.componentInstance.petId = this.petId();
    modalRef.componentInstance.ownerId = this.ownerId();
    modalRef.componentInstance.initialSurvey = surveyName;
    modalRef.componentInstance.app = this.app();
  }

}
